import React, { useState } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import IVButton from '@invideoio/uniformd/components/Button';
import RegexValidation from '@invideoio/web-shared/hooks/useForm/validator';
import { HeroMobileProps } from '../types';
import { CHECK_ICON_URL } from '@constants/trim-tool';
import {
  AmplitudeEvents,
  sendAmplitudeAnalyticEvent,
  sendBrazeAnalyticEvent,
} from '@utils/analytics';
import { sendEmailCampaign } from '@lib/API';

const Mobile = (props: HeroMobileProps) => {
  const { CTAUrl, CTAText, subInfo, inputPlaceholder, tempalteData } = props;
  const [email, setEmail] = useState('');
  const [sendEmail, setSendEmail] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const isEmailValid = (): boolean => {
    const emailValid = RegexValidation.Email.test(email);
    setEmailInvalid(!emailValid);
    return emailValid;
  };

  const onSubmit = async (event: any) => {
    event.preventDefault();
    if (isEmailValid()) {
      setSendEmail(true);
      sendAmplitudeAnalyticEvent(AmplitudeEvents.toolGetLink, {
        'Email Id': email,
      });
      sendBrazeAnalyticEvent({
        eventName: AmplitudeEvents.toolGetLink,
        eventProperties: {
          tool_link_email_id: email,
        },
        userProperties: {},
      });

      const savedEmails =
        localStorage.getItem(window.btoa('tools_mobile_email')) ||
        window.btoa('[]');

      if (savedEmails) {
        const emails = JSON.parse(window.atob(savedEmails));
        if (emails.indexOf(email) === -1) {
          const payload = {
            email: email,
            campaign: 'tools_mobile_email',
            template_data: tempalteData,
          };

          const res = await sendEmailCampaign({
            data: window.btoa(JSON.stringify(payload)),
          });

          if (res === true) {
            emails.push(email);
            localStorage.setItem(
              window.btoa('tools_mobile_email'),
              window.btoa(JSON.stringify(emails)),
            );
          }
        } else {
          setEmailSent(true);
        }
      }
    }
  };

  const onResetEmail = () => {
    setEmail('');
    setEmailInvalid(false);
    setSendEmail(false);
    setEmailSent(false);
  };

  return (
    <React.Fragment>
      <div
        className={ivclass(
          'iv-pt-10',
          'iv-text-center',
          'iv-text-black-50',
          'iv-text-body-xs md:iv-text-body-m',
          'iv-font-medium',
        )}
      >
        {subInfo}
      </div>
      <div className={ivclass('iv-pt-15 sm:iv-pt-10')}>
        <div
          className={ivclass(
            'iv-grid',
            'sm:iv-grid-cols-4 md:iv-grid-cols-8',
            'sm:iv-gap-20 md:iv-gap-25',
          )}
        >
          <div
            className={ivclass(
              'iv-relative',
              'sm:iv-col-span-4 md:iv-col-start-3 md:iv-col-span-4',
            )}
          >
            <div
              className={ivclass(
                'iv-absolute',
                'iv-top-0 iv-bottom-0 iv-left-0 iv-right-0',
                sendEmail ? 'iv-block' : 'iv-hidden',
              )}
            >
              {emailSent ? (
                <IVButton
                  className={ivclass(
                    'iv-flex',
                    'iv-justify-center iv-items-center',
                    'iv-w-full',
                    'iv-h-52',
                    'iv-bg-black-5',
                    'iv-rounded-full',
                  )}
                  onClick={() => onResetEmail()}
                >
                  <img
                    src={CHECK_ICON_URL}
                    alt="check"
                    width="20"
                    height="15"
                    // layout="fixed"
                  />
                  <span
                    className={ivclass(
                      'iv-pl-10',
                      'iv-text-body-xl',
                      'iv-text-grey-85',
                      'iv-font-semibold',
                    )}
                  >
                    Email Already sent
                  </span>
                </IVButton>
              ) : (
                <IVButton
                  className={ivclass(
                    'iv-flex',
                    'iv-justify-center iv-items-center',
                    'iv-w-full',
                    'iv-h-52',
                    'iv-bg-black-5',
                    'iv-rounded-full',
                  )}
                  onClick={() => onResetEmail()}
                >
                  <img
                    src={CHECK_ICON_URL}
                    alt="check"
                    width="20"
                    height="15"
                    // layout="fixed"
                  />
                  <span
                    className={ivclass(
                      'iv-pl-10',
                      'iv-text-body-xl',
                      'iv-text-grey-85',
                      'iv-font-semibold',
                    )}
                  >
                    Sent
                  </span>
                </IVButton>
              )}
            </div>
            <form
              onSubmit={onSubmit}
              noValidate
              className={ivclass(
                'iv-relative',
                sendEmail ? 'iv-invisible' : 'iv-visible',
              )}
            >
              <input
                type="text"
                name="email"
                placeholder={inputPlaceholder}
                autoComplete="off"
                className={ivclass(
                  'iv-w-full',
                  'iv-pl-20 iv-pr-[125px]',
                  'iv-h-52',
                  'iv-rounded-full',
                  'iv-bg-black-5',
                  'iv-text-grey-85',
                  'iv-placeholder-grey-60',
                  'iv-border-2 iv-border-solid',
                  'iv-border-transparent focus:iv-border-blue',
                  'iv-text-body-xl',
                  'iv-outline-none',
                  'iv-focus-effect',
                )}
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <div
                className={ivclass(
                  'iv-absolute',
                  'iv-right-[10px] iv-top-1/2',
                  'iv-translate-y-[-50%]',
                  'iv-focus-effect',
                )}
              >
                <IVButton
                  className={ivclass(
                    'iv-flex',
                    'iv-items-center',
                    'iv-h-32',
                    'iv-px-15',
                    'iv-rounded-full',
                    'iv-border-2 iv-border-solid iv-border-blue',
                    'iv-text-blue',
                    'iv-text-body-xl',
                    'iv-outline-none',
                    'iv-font-semibold',
                    'iv-btn-focus-effect',
                  )}
                >
                  {CTAText}
                </IVButton>
              </div>
            </form>
            {emailInvalid && (
              <div
                className={ivclass('iv-pt-5', 'iv-text-red', 'iv-text-body-l')}
              >
                Please enter a valid email
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Mobile;
